/**
 * @generated SignedSource<<efaed327c0b28605b65f16db08b4ffa1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoOverviewListItemFooter_Todo$data = {
  readonly assignedUsers: ReadonlyArray<{
    readonly assignedAt: string | null;
    readonly user: {
      readonly name: string;
    } | null;
  }>;
  readonly assigneeText: string;
  readonly tags: ReadonlyArray<{
    readonly color: string;
    readonly id: string;
    readonly title: string;
  }>;
  readonly " $fragmentType": "TodoOverviewListItemFooter_Todo";
};
export type TodoOverviewListItemFooter_Todo$key = {
  readonly " $data"?: TodoOverviewListItemFooter_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemFooter_Todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoOverviewListItemFooter_Todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategoryTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assigneeText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoAssignedUser",
      "kind": "LinkedField",
      "name": "assignedUsers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "775cb7a46abc8abc2db7a21b52ad8d4e";

export default node;
